import { motion } from 'framer-motion';

/**
 * Botanical leaf spinner — Wonder Herbals branded loading indicator
 */
export default function LoadingSpinner({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
    const dimensions = {
        sm: 'w-8 h-8',
        md: 'w-12 h-12',
        lg: 'w-20 h-20',
    };

    return (
        <div className="flex items-center justify-center">
            <motion.div
                className={`${dimensions[size]} text-wonder-forest`}
                animate={{ rotate: 360 }}
                transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M11 20A7 7 0 0 1 9.8 6.9C15.5 4.9 17 3.5 19 2c1 2 2 4.5 2 8 0 5.5-4.78 10-10 10Z" />
                    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" />
                </svg>
            </motion.div>
        </div>
    );
}

/**
 * Full-page loading fallback for Suspense
 */
export function PageLoader() {
    return (
        <div className="flex items-center justify-center min-h-screen bg-wonder-cream">
            <div className="text-center">
                <LoadingSpinner size="lg" />
                <p className="mt-4 font-accent text-sm text-wonder-sage">Loading...</p>
            </div>
        </div>
    );
}

/**
 * Inline section loader
 */
export function SectionLoader() {
    return (
        <div className="flex items-center justify-center py-20">
            <LoadingSpinner size="md" />
        </div>
    );
}
